import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TodoService } from '../../todo.service';
import { ActivatedRoute } from '@angular/router';
import { LocalUserService } from 'app/main/shared/services/localUser';
import { setDate } from 'date-fns';
import * as moment from 'moment';

@Component({
  selector: 'todo-my-day-sidenav',
  templateUrl: './my-day-sidenav.component.html',
  styleUrls: ['./my-day-sidenav.component.scss']
})
export class MyDaySidenavComponent implements OnInit {
  @Input()
  projects: any;

  @Output()
  update: EventEmitter<any> = new EventEmitter();

  tasks: any[] = [];

  selectedTask: any;


  isLoading = false;
  showIcon = false;
  progress = true;

  userId: string;
  prioritydata = null;
  setPriority: string;
  filteredProjects = [];

  delayedEvent = [];
  upComingEvent = [];
  suggestedEvent = [];
  currentDate: Date;


  constructor(
    private todoService: TodoService,
    private activatedRoute: ActivatedRoute,
    private localStore: LocalUserService

  ) {
    this.userId = localStore.getUserId()
  }


  updateTask(task) {
    this.progress = true;
    this.todoService
      .updateTask(this.userId, task.list_id, task.id, task)
      .subscribe(data => {
        this.update.emit();
        this.progress = false;
      });

    event.stopPropagation();
  }
  priorityData(event) {
    this.prioritydata = event;
    if (event != null) {
      if (event.value !== 'ALL') {
        this.filteredProjects = this.projects.filter(data => {
          return data.priority === event.value;
        });
      } else {
        this.filteredProjects = this.projects;
      }
    } else {
      this.filteredProjects = this.projects;
    }
  }

  deleteTask(event) {
    this.progress = true;
    this.todoService
      .deleteTask(this.userId, event.list_id, event.id)
      .subscribe(data => {
        this.projects.tasks = this.projects.tasks.filter(task => task.id !== event.id);
        this.priorityData(this.prioritydata);
        this.progress = false;
      });
  }

  getNextPriority(value) {
    if (value == 'LOW') {
      return 'MEDIUM'
    } else if (value == 'MEDIUM') {
      return 'HIGH'
    } else if (value = 'HIGH') {
      return 'LOW'
    }
  }

  changePriority(task) {
    task.priority = this.getNextPriority(task.priority)

    this.updateTask(task)
  }

  forTodayTasks() {
    // task.due_date.setDate(task.due_date.getDate() + 1).toDate()
    this.currentDate = new Date()
    this.tasks.forEach((tasks) => {
      let dueDate = new Date(tasks.due_date)
      if (moment(dueDate).startOf('day') < moment(this.currentDate).startOf('day') && tasks.due_date != null) {
        this.delayedEvent.push(tasks)
      }
      if (moment(dueDate).startOf('day') > moment(this.currentDate).startOf('day') && moment(dueDate).startOf('day') <= moment(this.currentDate).add(2, 'days').startOf('day') && tasks.due_date != null) {
        this.upComingEvent.push(tasks)
      }
      if (moment(dueDate).startOf('day') > moment(this.currentDate).add(2, 'days').startOf('day') || tasks.due_date == null) {
        this.suggestedEvent.push(tasks)
      }
    })
  }

  ngOnInit() {

    if (this.projects && this.projects.length) {
      this.projects.forEach((project) => this.tasks.push(...project.tasks.filter(task => task)))
    }
    this.forTodayTasks();
  }
  getProjectName(task) {
    let selected = this.projects.find((project => project.id === task.list_id))
    return selected ? selected.name : '';
  }

  addMyDay(task) {
    task.my_day = new Date();
    this.updateTask(task)
  }



  // lateDueDate(time: string, task) {
  //   task.due_date = new Date()
  //   if (time !== 'today') {
  //     //   task.due_date = currentDate
  //     // } else {
  //     task.due_date = task.due_date.setDate(task.due_date.getDate() + 1).toDate();
  //   }
  //   this.updateTask(task)
  // }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/my-day-sidenav/my-day-sidenav.component.ts